import {AbstractController} from "../../../common/controllers/AbstractController";
import {inject, Injectable, signal} from "@angular/core";
import {UserSessionRepository} from "../../../common/repositories/user-session.repository";
import {AppEventBus} from "../../../common/event-buses/app.event-bus";
import {ModelKey} from "../../../common/models/ModelKey";
import {MobileAppHeaderModel} from "../_models/MobileAppHeaderModel";
import {AppEventName} from "../../../common/event-buses/AppEventName";
import {AppEvent} from "../../../common/event-buses/AppEvent";

export const MK_MOBILE_APP_HEADER = new ModelKey<MobileAppHeaderModel>('MK_MOBILE_APP_HEADER');

@Injectable()
export class MobileAppHeaderController extends AbstractController {

  private readonly userSessionRepository = inject(UserSessionRepository);

  private readonly appEventBus = inject(AppEventBus);

  constructor() {
    super();

    this.addModel(MK_MOBILE_APP_HEADER, {
      impersonation$: signal(this.userSessionRepository.isImpersonation()),
    });

    this.sub(this.appEventBus.subscribe(AppEventName.NewUserSession, (event) => this.onNewUserSession(event)));
  }

  protected onNewUserSession(event: AppEvent): void {
    this.getModel(MK_MOBILE_APP_HEADER).impersonation$.set(this.userSessionRepository.isImpersonation());
  }
}
